/**
 * The equipment TAXONOMY, as `queryOptions` — `GET /equipment`.
 *
 * The whole list, most-used first (`EquipmentController`), which is also the order the creator's
 * canon draws its tiles in. It is not the catalogue's equipment facet: that one only knows the
 * pieces some movement already names, and a trainer authoring a new movement must be offered every
 * piece there is.
 *
 * Reference data nothing here edits, so the same thirty minutes the catalogue keeps. Projected
 * through the row's own equipment mapper, so an id-less or nameless piece is dropped here exactly as
 * it is on a movement.
 */

import { queryOptions } from '@tanstack/react-query';

import {
  getEquipment,
  getGetEquipmentQueryKey,
} from '~/shared/api/generated/endpoints/equipment/equipment';

import { toEquipment } from '../model/exerciseListItem';

export function equipmentQueryOptions() {
  return queryOptions({
    queryKey: getGetEquipmentQueryKey(),
    queryFn: ({ signal }) => getEquipment(undefined, signal),
    select: toEquipment,
    staleTime: 30 * 60 * 1000,
  });
}
